'use strict';

// Constructor
var CommonHeader = function () {
    $('.title-bar').waypoint(function ($direction) {
        if ($direction === 'up') {
            $('.inner-page .header').removeClass('stuck');
            $('body').removeClass('stuck');
        } else {
            $('.inner-page .header').addClass('stuck');
            $('body').addClass('stuck');
        }
    }, {
        offset: '90px'
    });
  
};

module.exports = CommonHeader;
